import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {DomSanitizer, SafeHtml, SafeResourceUrl} from '@angular/platform-browser';
import { DocumentData } from '../../../dms/annotation-controller/document-data.type';
import {Mimetype} from '../../../shared/mimetype';
import { EformAPI } from 'app/e-form/e-form.api';
@Component({
   selector: 'app-preview-document-dialog',
   templateUrl: './preview-document-dialog.component.html',
   styleUrls: ['./preview-document-dialog.component.css']
})
export class PreviewDocumentDialogComponent implements OnInit {
   pdfUrl: SafeResourceUrl;
   loaded = false;
   public nameFile: any;
   size = 5242880;
   text: string;
   svg: SafeHtml;
   canNotPreview: boolean;
   imageUrl: string;
   videoUrl: string;
   audioUrl: string;
   types: any[];
   post = 'ส่ง';
   error: string;
   documentData: DocumentData;
   docUrl: string;
   sections: any;

   constructor(private dialogRef: MatDialogRef<PreviewDocumentDialogComponent>, private sanitizer: DomSanitizer,
               private changeDetector: ChangeDetectorRef,
               @Inject(MAT_DIALOG_DATA) public data: any) {
   }

   ngOnInit() {
      this.initDocument();
   }

   initDocument(): void {
      this.nameFile = this.data.docName;
      const token = this.data.service.user.token;
      let mimeType = this.data.mimetype;
      if (this.nameFile.endsWith('.csv')) {
         mimeType = 'text/csv';
      }
      let contentUrl = '/content';
      if (!this.data.show) {
         contentUrl = '/share-public/content';
      }
      const docId = this.data.docId;
      const watermark = this.data.watermark;
      const perm = {'create': false, 'delete': false, 'edit': false, 'print': false, 'write': false};
      const url = contentUrl + '?id=' + docId + '&token=' + token;
      const checkType = Mimetype.checkMimeType(mimeType);
      if (checkType === 'doc' && this.data.size <= this.size) {
         const file = encodeURIComponent(this.data.service.url + url + '&' + Date.now());
         this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl('assets/pdfjs/web/viewer.html?file=' + file);
         this.docUrl = this.data.service.url + url + '&isPdfTron=true&' + '&' + Date.now();
         this.documentData = {
            url: this.docUrl,
            fileName: this.nameFile,
            fileFormat: "pdf", // Office files stored in zDOX are converted to PDF, but the file name/extension may not change to .pdf
            type: "",
            mimeType: mimeType,
            docId: docId,
            path: "",
            statusStartFlow: false,
            statusDocument: "",
            isPermissions: perm,
            watermark: watermark,
            actionType: "task",
         };
      } else if (checkType === 'img') {
         this.imageUrl = this.data.service.url + url + '&' + Date.now();
         this.documentData = {
            url: this.imageUrl,
            fileName: this.nameFile,
            type: "",
            mimeType: mimeType,
            docId: docId,
            path: "",
            statusStartFlow: false,
            statusDocument: "",
            isPermissions: perm,
            watermark: watermark,
            actionType: "task",
         };
      }  else if (checkType === 'text') {
         this.data.service.get(url, {responseType: 'text'}).subscribe(data => {
            this.text = data;
            this.loaded = true;
         });
      } else {
         this.canNotPreview = true;
         this.loaded = true;
      }
   }

   frameLoaded(iframe: any) {
      const that = this;
      const document = iframe.contentWindow.document;
      document.addEventListener('pagesinit', function () {
         that.loaded = true;
         that.changeDetector.detectChanges();
      });
   }
}
